import { render, staticRenderFns } from "./PersonProve.vue?vue&type=template&id=4410cd26&scoped=true"
import script from "./PersonProve.vue?vue&type=script&lang=js"
export * from "./PersonProve.vue?vue&type=script&lang=js"
import style0 from "./PersonProve.vue?vue&type=style&index=0&id=4410cd26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4410cd26",
  null
  
)

export default component.exports